<template>
  <main class="page">
    <page-header :title="scheduleMode ? '选择客户' : '客户'" :subtitle="scheduleMode ? '选择要安排跟进或来访的客户' : (total ? '共 ' + total + ' 位' : '')" :back="scheduleMode" @back="backToSchedule">
      <router-link v-if="!scheduleMode" class="icon-button solid" to="/customer/check" aria-label="新增客户">
        <app-icon name="plus" />
      </router-link>
    </page-header>
    <div class="list-filters" :class="{ 'below-header': scheduleMode }">
      <form class="search-box" @submit.prevent="search">
        <app-icon name="search" />
        <input v-model="keyword" type="search" enterkeyhint="search" placeholder="姓名、电话、需求关键词" aria-label="搜索客户" />
        <router-link :to="filterLocation" class="filter-link" :class="{ on: filtered }" aria-label="更多筛选">
          <app-icon name="filter" />
        </router-link>
      </form>
      <div class="chips">
        <button class="chip" :class="{ active: !Number(searchState.searchStatus) }" @click="setStatus('')">全部</button>
        <button v-for="item in quickStatuses" :key="item.key" class="chip" :class="{ active: Number(searchState.searchStatus) === Number(item.key) }" @click="setStatus(item.key)">
          {{ item.value }}
        </button>
      </div>
      <div v-if="filtered" class="filter-note">
        已按筛选条件显示
        <router-link :to="filterLocation">调整筛选</router-link>
      </div>
    </div>
    <p v-if="syncError" class="error-message" role="status">{{ syncError }}<button class="text-button" @click="syncChangedCustomers">重试同步</button></p>
    <van-list v-model="loading" :finished="finished || !!error || syncing" @load="loadMore">
      <div v-if="list.length" class="c-list" style="margin-top:12px">
        <customer-card v-for="item in list" :key="item.id" :customer="item" @open="open" />
      </div>
    </van-list>
    <p v-if="error" class="error-message">
      {{ error }}
      <button class="text-button" @click="loadMore">重试</button>
    </p>
    <div v-if="finished && !list.length" class="empty-state">
      <app-icon name="search" />
      <strong>没有找到符合条件的客户</strong>
      <p>换个关键词，或调整筛选条件。</p>
    </div>
    <p v-if="finished && list.length" class="loading-state">已显示全部 {{ total }} 位客户</p>
  </main>
</template>
<script>
import paged from '../../common/paged'
import { listParams } from '../../common/customer'
import { validDay, scheduleLocation } from '../../common/schedule'
export default {
  mixins: [
    paged('/api/customer/list', 'customers', function() {
      return listParams(this.$store.state.search)
    }, true)
  ],
  data() {
    return { keyword: this.$store.state.search.searchKeyword, searches: {} }
  },
  computed: {
    scheduleMode() {
      return !!validDay(this.$route.query.schedule_date)
    },
    filterLocation() {
      return {
        path: '/customer/search',
        query: this.scheduleMode
          ? {
              schedule_date: this.$route.query.schedule_date,
              schedule_type: this.$route.query.schedule_type
            }
          : {}
      }
    },
    searchState() {
      return this.$store.state.search
    },
    quickStatuses() {
      return ((this.searches.status && this.searches.status.list) || []).filter(
        item => [1, 2, 4].indexOf(Number(item.key)) >= 0
      )
    },
    filtered() {
      const s = this.searchState
      return !!(
        s.searchLabels ||
        s.searchStartTime ||
        s.searchEndTime ||
        s.searchSubjects.length ||
        s.searchEmployees.length ||
        s.searchChannels.length ||
        s.searchSourceChannelV2.length ||
        s.searchTotalBudgetRange.length ||
        s.searchPriceAcceptanceLevel.length ||
        s.searchPurposeV2.length
      )
    }
  },
  async created() {
    try {
      let data = this.$store.state.customer.state.searches
      if (!data.status) {
        data = (await this.$api.post('/api/base/searches', {})).data
        this.$store.state.customer.state.searches = data
      }
      this.searches = data
    } catch (e) {
      /* 列表本身可独立使用。 */
    }
  },
  methods: {
    search() {
      if (this.fetching || this.syncing) return
      this.$store.state.search.searchKeyword = this.keyword.trim()
      this.resetPosition()
      this.reloadList()
    },
    setStatus(status) {
      if (this.fetching || this.syncing) return
      this.$store.state.search.searchStatus = status
      this.resetPosition()
      this.reloadList()
    },
    resetPosition() {
      const active = document.activeElement
      if (active && active.tagName === 'INPUT') active.blur()
      window.scrollTo(0, 0)
    },
    backToSchedule() {
      this.$router.replace(
        scheduleLocation(this.$route.query.schedule_date, this.$route.query.schedule_type)
      )
    },
    open(item) {
      if (this.scheduleMode) {
        this.$router.push({
          path: '/customer/edit/' + item.id + '/schedule',
          query: {
            date: this.$route.query.schedule_date,
            type: this.$route.query.schedule_type === 'visit' ? 'visit' : 'follow',
            plan: '1'
          }
        })
      } else this.$router.push('/customer/detail/' + item.id + '/customer')
    },
    follow(item) {
      this.$router.push('/customer/edit/' + item.id + '/customer')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customer/index.vue